export function GeneralLiabilityIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" {...props}>
      {/* umbrella canopy */}
      <path d="M8 24c0-8.8 7.2-16 16-16s16 7.2 16 16H8z" fill="#10B981" opacity="0.15" />
      <path
        d="M8 24c0-8.8 7.2-16 16-16s16 7.2 16 16H8z"
        stroke="#10B981"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      {/* handle */}
      <path d="M24 24v14c0 2.2-1.8 4-4 4" stroke="#10B981" strokeWidth="2.5" strokeLinecap="round" />
      {/* ribs */}
      <path d="M16 24c0-4 3.6-8 8-8M24 16c4.4 0 8 4 8 8" stroke="#10B981" strokeWidth="1.5" opacity="0.5" />
    </svg>
  )
}
